webpackJsonp([254572558124955],{

/***/ 813:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"algolia":{"appId":"M6UTFZCWVO","searchOnlyApiKey":"476b740fa66a19ef00a684ce8319c5dd","indexName":"MartianRace"},"facebook":{"appId":"1184472234930745"}}}},"pathContext":{}}

/***/ })

});


// WEBPACK FOOTER //
// path---search-8f16aa501b4bf2e5fc9b.js